import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-all-documents-info',
  templateUrl: './all-documents-info.component.html',
  styleUrls: ['./all-documents-info.component.scss']
})
export class AllDocumentsInfoComponent {

  constructor(private translateService: TranslateService) {
  }


  getEmailLink() {
    const email = this.translateService.instant('Documents.All.Help.Footer.Email.Value');
    return `mailto:${email}`;
  }

  getWhatsAppLink() {
    const phone = this.translateService.instant('Documents.All.Help.Footer.WhatsApp.Value');
    return `https://api.whatsapp.com/send/?phone=${phone}&text&type=phone_number&app_absent=0`;
  }
}
